import {creates, hoistCmp} from '@xh/hoist/core';
import {HistoricPerformanceWidgetModel} from './HistoricPerformanceWidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {chart} from '@xh/hoist/cmp/chart';
import {toolbarSep} from '@xh/hoist/desktop/cmp/toolbar';
import {widgetToolbar} from '../../../../cmp/widget/WidgetToolbar';
import {widgetToolbarButton} from '../../../../cmp/widget/WidgetToolbarButton';

export const historicPerformanceWidget = hoistCmp.factory({
    model: creates(() => HistoricPerformanceWidgetModel),
    render({model}) {
        return panel({
            item: chart(),
            bbar: bbar()
        });
    }
});

const bbar = hoistCmp.factory<HistoricPerformanceWidgetModel>(({model}) =>
    widgetToolbar({
        items: [
            widgetToolbarButton({
                text: model.logScale ? 'Log' : 'Linear',
                active: model.logScale,
                onClick: () => model.toggleLogScale()
            }),
            toolbarSep(),
            ...model.seriesMeta.map(s =>
                widgetToolbarButton({
                    key: s.key,
                    text: s.name,
                    style: {
                        '--widget-toolbar-text-color': s.color,
                        opacity: s.visible ? 1 : 0.4
                    } as React.CSSProperties,
                    onClick: () => model.toggleSeries(s.key)
                })
            )
        ]
    })
);
